import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { httpLoader } from './angular-common.module';

@NgModule({
    imports: [TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: httpLoader, // AoT requires an exported function for factories
            deps: [HttpClient]
        }
    })],
    exports: [TranslateModule]
})
export class AppTranslateModule { }
